// extracted by mini-css-extract-plugin
module.exports =  {"root":"iaLoc0U5pJgkPAPaXyMY","dark":"eq8NmALsGftg45zfW7a2","light":"dN8M5S8_7UpJSu5j8z3q"};